export default __webpack_public_path__ + "static/media/SOME_Greeter.27794dc7.png";